import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

import * as styles from './RequestProfileHeaderFooterAddNewText.module.css'

function RequestProfileHeaderFooterAddNewText({ qaName }) {
  const { t } = useTranslation()

  return (
    <Text
      isSecondary
      className={styles.RequestProfileHeaderFooterAddNewText}
      qaName={qaName}
    >
      {t('RequestProfile.HeaderFooterAddNewTextKey')}
    </Text>
  )
}

export default RequestProfileHeaderFooterAddNewText
